import { render } from "./DetaineeCallbackRecord.vue?vue&type=template&id=c2cd9e38&scoped=true"
import script from "./DetaineeCallbackRecord.vue?vue&type=script&lang=js"
export * from "./DetaineeCallbackRecord.vue?vue&type=script&lang=js"

import "./DetaineeCallbackRecord.vue?vue&type=style&index=0&id=c2cd9e38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2cd9e38"]])

export default __exports__